import { Controller } from "@hotwired/stimulus"

const COMPACT_BY_DEFAULT_MAX_WIDTH = 992
const STORAGE_KEY = 'sidebarState'
// Saved 'expand' on every load, so only 'shrink' was a real choice
const LEGACY_STORAGE_KEY = 'sideState'

// Connects to data-controller="navigation--sidebar"
export default class extends Controller {
  connect() {
    this.initialState() === 'shrink' ? this.shrink() : this.expand()
  }

  toggle() {
    this.sideState === 'shrink' ? this.expand() : this.shrink()
    this.saveState()
  }

  shrink() {
    this.sideState = 'shrink'
    this.element.querySelectorAll('[data-hide-on-shrink]').forEach(e => e.classList.add('d-none'))
    this.element.querySelectorAll('[data-hide-on-expand]').forEach(e => e.classList.remove('d-none'))
  }

  expand() {
    this.sideState = 'expand'
    this.element.querySelectorAll('[data-hide-on-shrink]').forEach(e => e.classList.remove('d-none'))
    this.element.querySelectorAll('[data-hide-on-expand]').forEach(e => e.classList.add('d-none'))
  }

  initialState() {
    const saved = this.readStorage(STORAGE_KEY)
    if (saved === 'shrink' || saved === 'expand') return saved
    if (this.readStorage(LEGACY_STORAGE_KEY) === 'shrink') return 'shrink'

    return window.innerWidth < COMPACT_BY_DEFAULT_MAX_WIDTH ? 'shrink' : 'expand'
  }

  saveState() {
    try {
      localStorage.setItem(STORAGE_KEY, this.sideState)
    } catch {
      // storage unavailable
    }
  }

  readStorage(key) {
    try {
      return localStorage.getItem(key)
    } catch {
      return null
    }
  }
}
